import { Component, OnInit , Inject, ViewChild } from '@angular/core';
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import {Router} from "@angular/router"
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpErrorResponse} from '@angular/common/http';
import { MatDialog} from '@angular/material/dialog';
import { environment } from '../../environments/environment';
import { DlgTrabajandoComponent } from '../components/dlg-trabajando/dlg-trabajando.component';
import { DlgErrorComponent } from '../components/dlg-error/dlg-error.component';
import { MatPaginator} from '@angular/material/paginator'
import { MatTableDataSource} from '@angular/material/table'
import { DlgLocalidadComponent } from '../components/dlg-localidad/dlg-localidad.component';

@Component({
  selector: 'app-localidad',
  templateUrl: './localidad.component.html',
  styleUrls: ['./localidad.component.css']
})
export class LocalidadComponent implements OnInit {

  escondeFraseNoHay=false;
  displayedColumns: string[] = ['acciones','habilitado','nombre'];
  dataSource = new MatTableDataSource();
  @ViewChild('paginador') paginador: MatPaginator;

  constructor(
    public dialog: MatDialog,
    private httpClient: HttpClient,
    private router: Router,
    @Inject(SESSION_STORAGE) private storage: StorageService,
  ) { }

  ngOnInit(): void {
    if (this.storage.get("idConexion") == null) {
      this.router.navigate(['/']);
      return;
    }
    this.buscarDatos();
  }

  cerrarDialogo(dialogoActual) {
    dialogoActual.close();
  }

  buscarDatos() {
    let dlgTrabajando = this.dialog.open(DlgTrabajandoComponent, {
      width: '600px',
      disableClose: true
    });
    dlgTrabajando.componentInstance.titulo = "";
    dlgTrabajando.componentInstance.texto = "Buscando las localidades";

    this.httpClient.get(environment.servidorHttp + 'Sistema/leerLocalidades'
      , {
        params: { 
          "idConexion": this.storage.get("idConexion"),
          "soloHabilitados": '0'
        },
        headers: {
          "Authorization": 'Bearer ' + this.storage.get("token"),
        }
      })
      .subscribe(data => {
        this.cerrarDialogo(dlgTrabajando);
        if (data['resultado']['msgError']['valorDevuelto'] == "01") {
          let dlgError = this.dialog.open(DlgErrorComponent, {
            width: '600px',
            disableClose: true
          });
          dlgError.componentInstance.titulo = "Error al buscar las localidades";
          dlgError.componentInstance.texto = data['resultado']['msgError']['mensaje'];
        } else if (data['resultado']['msgError']['valorDevuelto'] == "10") {
          let dlgError = this.dialog.open(DlgErrorComponent, {
            width: '600px',
            disableClose: true
          });
          dlgError.componentInstance.titulo = "Error al buscar las localidades";
          dlgError.componentInstance.texto = data['resultado']['msgError']['mensaje'];
          this.router.navigate(['/']);
        } else {
          if (data['resultado']['datos'] == undefined) {
            this.escondeFraseNoHay = false;
            return;
          }
          else {
            this.escondeFraseNoHay = true;
            this.dataSource = new MatTableDataSource<any>(data['resultado']['datos']);
            this.dataSource.paginator = this.paginador;
            this.paginador._intl.itemsPerPageLabel = 'Localidades por hoja';
            this.paginador._intl.nextPageLabel  = 'Proxima hoja';
            this.paginador._intl.previousPageLabel  = 'Hoja anterior';
            this.paginador._intl.lastPageLabel  = 'Última hoja';
            this.paginador._intl.firstPageLabel  = 'Primera hoja';
            this.paginador._intl.getRangeLabel = (page: number, pageSize: number, length: number) => {
              return 'De '+((page * pageSize) + 1) + ' a ' + ((page * pageSize) + pageSize) + ' de ' + length; 
            }
          }
        }
      },
        (error: HttpErrorResponse) => {
          this.cerrarDialogo(dlgTrabajando);
          let dlgError = this.dialog.open(DlgErrorComponent, {
            width: '600px',
            disableClose: true
          });
          if (error.status.toString() == "401") {
            dlgError.componentInstance.titulo = "Error al buscar las localidades";
            dlgError.componentInstance.texto = "Su sesión ha finalizado";
            this.router.navigate(['/']);
          } else {
            dlgError.componentInstance.titulo = "Error al buscar las localidades";
            dlgError.componentInstance.texto = "Error en Servidor: " + error.error.text + " (" + error.status + ")";
          } 
        });
  }

  public buscar = (value: string) => {
    this.dataSource.filter = value.trim().toLocaleLowerCase();
  }

  volver(){
    this.router.navigate(['/configuracion'])
  }

  modificar(idTipoDoc){
    let dlgMod = this.dialog.open(DlgLocalidadComponent, {
      width: '60vw',
      height:'60vh',
      disableClose:true
    });
    dlgMod.componentInstance.idActual=idTipoDoc;
    dlgMod.afterClosed().subscribe(
        data => {
          if (data.mensaje=="almaceno"){
            this.buscarDatos();
          }
        }
    );
  }
}
